
module.exports = function(app) {

  app.ports.gotoSSO && app.ports.gotoSSO.subscribe(async function(ssoUrl) {
    window.location = ssoUrl;
  });

}
